module.exports = __webpack_public_path__ + "static/Resume-93847edf34c7f5e381f5d93f26d2e74e.pdf";